<script setup lang="ts">
import { ref } from "vue";
import type { SplitterHandleProps } from "./splitter.types";
import { useSplitterHandle } from "composables/useSplitter";

const props = withDefaults(defineProps<SplitterHandleProps>(), {
  disabled: false,
});

const handleRef = ref<HTMLElement | null>(null);
const { classes, indicatorClass, ariaAttrs, onPointerDown, onClick } = useSplitterHandle({ props, handleRef });
</script>

<template>
  <div
    ref="handleRef"
    part="handle"
    :class="classes"
    class="e-splitter-handle"
    v-bind="ariaAttrs"
    @pointerdown="onPointerDown"
    @click="onClick"
  >
    <slot />
    <div part="indicator" :class="indicatorClass" aria-hidden="true"></div>
  </div>
</template>

<style>
:host {
  display: contents;
  color: var(--color-elevation-950);
}
</style>
